module.exports = __webpack_public_path__ + "img/knsu_gallery12.c3a8013f.jpg";